import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'services/auth/hooks';
import { POST_SSO_REDIRECT_KEY } from 'services/auth/utils/ssoRedirect';
import { PrivateRoute } from 'services/navigation/components/PrivateRoute';
import { Paths } from 'services/navigation/paths';
import { AtsEntryPage } from './AtsEntryPage';

// Google and SSO logins reload the page and lose router state. PublicRoute
// reads this key after any login and sends the user back here.
const AtsLoginRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      sessionStorage.setItem(
        POST_SSO_REDIRECT_KEY,
        `${location.pathname}${location.search}`
      );
    } catch {
      // Storage can be blocked in a third-party frame; login must still open.
    }
    navigate(Paths.LOGIN, { replace: true, state: { from: location } });
  }, [location, navigate]);

  return null;
};

export const AtsEntryRoute: React.FC = () => {
  const { userAuth, isLoading } = useAuth();

  if (!isLoading && userAuth !== undefined && !userAuth) {
    return <AtsLoginRedirect />;
  }

  return (
    <PrivateRoute
      hideNavbar
      skipOrganizationChecks
      element={<AtsEntryPage />}
    />
  );
};
